module.exports = __webpack_public_path__ + "static/media/auth0-create-tenant-step0.6134af1c.png";